import { createAsyncThunk } from "@reduxjs/toolkit";

import { downloadFile } from "core/request_utils";

export const downloadSomOfferJust = createAsyncThunk("som/downloadSomOfferJust", async ({ justId, fileName }, { rejectWithValue, extra }) => {
	try {
		const { data } = await extra.apiSom.getJustFile({ justId });

		if (!data) {
			throw new Error();
		}

		downloadFile({ data }, fileName);
	} catch (e) {
		return rejectWithValue(e);
	}
});
